export class FlowModel {
  constructor() {
    this.nodes = [];
    this.edges = [];
  }

  // Node operations
  addNode(node) {
    // Add isUpdated attribute if not present
    const nodeWithUpdateFlag = {
      ...node,
      isUpdated: node.isUpdated !== undefined ? node.isUpdated : false,
    };
    this.nodes.push(nodeWithUpdateFlag);
  }

  updateNode(id, data) {
    const nodeIndex = this.nodes.findIndex((node) => node.id === id);
    if (nodeIndex !== -1) {
      // Update both data and position if provided
      const updatedNode = { ...this.nodes[nodeIndex] };

      // Update data
      updatedNode.data = { ...updatedNode.data, ...data };

      // Update position if provided in data
      if (data.position) {
        updatedNode.position = data.position;
      }

      // Set isUpdated to true when node is modified
      updatedNode.isUpdated = true;

      this.nodes[nodeIndex] = updatedNode;
    }
  }

  deleteNode(id) {
    this.nodes = this.nodes.filter((node) => node.id !== id);
    // Also remove connected edges
    this.edges = this.edges.filter(
      (edge) => edge.source !== id && edge.target !== id
    );
  }

  getNode(id) {
    return this.nodes.find((node) => node.id === id);
  }

  getAllNodes() {
    return [...this.nodes];
  }

  // Edge operations
  addEdge(edge) {
    this.edges.push(edge);
  }

  deleteEdge(id) {
    console.log("=== FlowModel deleteEdge ===", {
      edgeId: id,
      edgesBefore: this.edges.length,
      edgeToDelete: this.edges.find((e) => e.id === id),
    });
    this.edges = this.edges.filter((edge) => edge.id !== id);
    console.log("=== FlowModel deleteEdge - COMPLETED ===", {
      edgeId: id,
      edgesAfter: this.edges.length,
    });
  }

  getAllEdges() {
    return [...this.edges];
  }

  // State operations
  getState() {
    return {
      nodes: this.getAllNodes(),
      edges: this.getAllEdges(),
    };
  }

  setState(state) {
    // Ensure all nodes have isUpdated attribute when importing
    this.nodes = state.nodes.map(node => ({
      ...node,
      isUpdated: node.isUpdated !== undefined ? node.isUpdated : false
    }));
    this.edges = [...state.edges];
  }

  // Utility methods
  generateNodeId() {
    return `node_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  }

  generateEdgeId() {
    return `edge_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  }

  // Validation methods
  isValidNode(node) {
    return node.id && node.type && node.position && node.data;
  }

  isValidEdge(edge) {
    return !!(edge.id && edge.source && edge.target);
  }

  canConnect(sourceId, targetId) {
    console.log("=== FlowModel canConnect ===", {
      sourceId,
      targetId,
      availableNodes: this.nodes.map((n) => n.id),
    });

    const sourceNode = this.getNode(sourceId);
    const targetNode = this.getNode(targetId);

    console.log("=== FlowModel canConnect - Nodes Found ===", {
      sourceNode: sourceNode ? sourceNode.id : null,
      targetNode: targetNode ? targetNode.id : null,
    });

    if (!sourceNode || !targetNode) {
      console.log("=== FlowModel canConnect - FAILED: Nodes not found ===");
      return false;
    }

    // Prevent self-connection
    if (sourceId === targetId) {
      console.log("=== FlowModel canConnect - FAILED: Self-connection ===");
      return false;
    }

    // Check if connection already exists
    const existingEdge = this.edges.find(
      (edge) => edge.source === sourceId && edge.target === targetId
    );

    const canConnect = !existingEdge;
    console.log("=== FlowModel canConnect - RESULT ===", {
      canConnect,
      existingEdge: existingEdge ? existingEdge.id : null,
    });

    return canConnect;
  }
}
